<!-- 丛台先锋统计 -->
<template>
    <div class='wrapper'>
        <div id="container" class="ctmap"></div>
        <div class="clear" @click="clear" v-show="!initStatus">清除</div>
        <!-- <div class="clear" @mousedown="clear" v-show="!initStatus" 
            @mouseover="mouseover"
            @mouseout="mouseout">
            <Icon type="md-trash" v-if="!isOver"/>
            <div v-else>清除</div>
        </div> -->
        <div class="content_container box box_v">
           <!--页面标题-->
            <div class="box box_between">
                <div class="title_top title_top_left">{{date}}</div>
                <div class="title_center_bg">
                    <div class="title_center">丛台区基层党建平台</div>
                </div>
                <div class="title_top title_top_right box box_center">
                    <div class="">{{weather}}</div>
                    <img :src="weatherPic" class="weatherPic"/>
                </div>
                
            </div>
            
            <!--页面内容-->
            <div class="box_f1 box box_between">
                <div class="content_left box box_v">
                    <left1 class="item box_f1"></left1>
                    <left2 class="item box_f1" 
                        :initStatus="initStatus"
                        @selectParty="selectParty"></left2>
                    <left3 class="item box_f1"></left3>
                    <left4 class="item box_f1" 
                        :initStatus="initStatus"
                        @selectGrid="selectGrid"></left4>
                </div>
                <div v-if="showPartyDetail" class="content_center">
                    <center1 
                        :partyName="partyName"
                        :partyId="partyId"
                        @close="close"></center1>
                </div>
                <div class="content_right  box box_v">
                    <right1 class="item box_f1"></right1>
                    <right2 class="item box_f1"></right2>
                    <right3 class="item box_f1"></right3>
                    <right4 class="item box_f1"></right4>
                </div>
            </div>
            <!-- <div class="content_left box box_v">
                <left1 class="item box_f1"></left1>
                <left2 class="item box_f1" 
                    :initStatus="initStatus"
                    @selectParty="selectParty"></left2>
                <left3 class="item box_f1"></left3>
                <left4 class="item box_f1" 
                    :initStatus="initStatus"
                    @selectGrid="selectGrid"></left4>
            </div>
            <div v-if="showPartyDetail" class="content_center">

            </div>
            <div class="content_right  box box_v">
                <right1 class="item box_f1"></right1>
                <right2 class="item box_f1"></right2>
                <right3 class="item box_f1"></right3>
                <right4 class="item box_f1"></right4>
            </div> -->

        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
var map
import axios from "axios";
import left1 from './components/left1'
import left2 from './components/left2'
import left3 from './components/left3'
import left4 from './components/left4'
import right1 from './components/right1'
import right2 from './components/right2'
import right3 from './components/right3'
import right4 from './components/right4'
import center1 from './components/center1'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {left1,left2,left3,left4,right1,right2,right3,right4,center1},
    data() {
    //这里存放数据
        return {
            date:'',
            weather:'',
            weatherPic:'',
            initStatus:true,//地图初始状态
            selectIndex:-1,//元素选择初始状态
            polygons:[],//丛台区位置
            isOver:false,
            showPartyDetail:false,
            partyName:'',
            partyId:'',
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        mouseover(){
            this.isOver = true
        },
        mouseout(){
            this.isOver = false
        },
        initMap(areaName="丛台区"){
            let that = this
            // 初始化地图
            // map = new AMap.Map('container', {
            //     resizeEnable: true, //是否监控地图容器尺寸变化
            //    scrollWheel:true,
            //    zoomEnable:true
            //     //features:['road']
            // });
            map = new AMap.Map('container')
                var districtSearch = new AMap.DistrictSearch({
                    // 关键字对应的行政区级别，country表示国家
                    subdistrict: 0,   //获取边界不需要返回下级行政区
                    extensions: 'all',  //返回行政区边界坐标组等具体信息
                    level: 'district'  //查询行政级别为 市
                })

                // 搜索所有省/直辖市信息
                districtSearch.search(areaName, function(status, result) {
                    console.log(status)
                    console.log(result)
                    // 查询成功时，result即为对应的行政区信息
                    if(status=='complete'){
                        console.log('------here------')
                        console.log(result.districtList[0])
                        // {
                        //     O: 116.72552400000001
                        //     P: 39.624071
                        //     lat: 39.624071
                        //     lng: 116.725524
                        // }
                        that.getData(result.districtList[0]);
                    }
                })
            //})

        },
        getData(data,level) {
            let polygons = []
            var bounds = data.boundaries;
            console.log(bounds)
            if (bounds) {

                for (var i = 0, l = bounds.length; i < l; i++) {
                    console.log(bounds[i])
                    var polygon = new AMap.Polygon({
                        map: map,
                        strokeWeight: 1,
                        strokeColor: '#f20',
                        fillColor: '#f20',
                        fillOpacity: 0.4,
                        path: bounds[i]
                    });
                    polygons.push(polygon);
                }
                this.polygons = polygons
                map.add(polygons)
                map.setFitView(polygons);//地图自适应
                map.setZoom(10.5)
            }
        },
        getWeather(){
            axios({
                url:this.urlobj.getWeather+'?area=邯郸',
                headers:{
                    Authorization: "APPCODE b0ca862be8e8409a91d735179f4d07ed"
                },
                method:'get',
                
            }).then(res=>{
                 console.log('success',res)
                 res = res.data
                    let data = res.showapi_res_body.now
                    this.weather = '空气质量'+data.aqiDetail.quality+'  '+data.weather+'  '+data.temperature+'℃'
                    this.weatherPic = data.weather_pic
            })
        },
        //地图上添加定位坐标
        selectParty(partyData){
            console.log(partyData)
            this.initStatus = false
            let markerList = []
            let marker = null
            let coordinate = ''
            let partyList = partyData.partyList
            partyList.forEach(item=>{
                //x 长，y短
                coordinate = (item.coordinate && item.coordinate.length>3)?JSON.parse(item.coordinate):''
                if(coordinate && 
                coordinate.x != 'undefined' && coordinate.y != 'undefined' && 
                coordinate.x && coordinate.y
                ){
                     let x = item.partyName.length/2
                    if(item.partyName.indexOf('工委')>-1){
                       
                        marker = new AMap.Marker({
                            position: new AMap.LngLat(
                                coordinate.x,
                                coordinate.y
                            ), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                            icon: require('../../assets/images/monitorctxf/dw.gif'),
                            label:{
                                content: "<div class='partyName'>" + item.partyName + "</div>",
                                offset: new AMap.Pixel(-x*22, -50),
                            },
                            clickable:true
                        });
                    }else{
                        marker = new AMap.Marker({
                            position: new AMap.LngLat(
                                coordinate.x,
                                coordinate.y
                            ), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                            icon: require('../../assets/images/monitorctxf/dw-small.gif'),
                            label:{
                                content: "<div class='partyName partyNameSmall'>" + item.partyName + "</div>",
                                offset: new AMap.Pixel(-x*16, -30),
                            },
                            clickable:true
                        });
                    }
                    marker.id = item.id
                    marker.partyName= item.partyName
                    marker.on('click',(e)=>{
                        this.partyId = e.target.id
                        this.partyName = e.target.partyName
                        this.showPartyDetail = true
                    })
                    markerList.push(marker);
                }
                
                console.log(markerList)
            })
            map.clearMap();
            map.add(markerList);
            map.setFitView(markerList)
            //map.setZoom(14)
        },
        close(){
            this.partyId = ''
            this.partyName = ''
            this.showPartyDetail = false
        },
        //地图上添加网格坐标
        selectGrid(gridList){
            
            let color = ['#FF2F5B','#FF912F','#2FD1FF','#2F78FF','#2FFF51']
           // 红#FF2F5B  黄 #FF912F 蓝 #2FD1FF 紫 #2F78FF 绿 #2FFF51
            this.initStatus = false
            let polygons = []
            let color_index = 0

            gridList.forEach((item,index)=>{
                console.log('2222222')
                let coordinateList = item.coordinateList
                
                if(coordinateList){
                    console.log('3333333')
                    coordinateList = JSON.parse(coordinateList)
                    let newdata = []
                    coordinateList.forEach(item=>{
                        //console.log(item)
                        //item = JSON.parse(item)
                        if(item && 
                            item.lng != 'undefined' && item.lat != 'undefined' && 
                            item.lng && item.lat
                        ){
                            newdata.push(new AMap.LngLat(item.lng,item.lat)) 
                        }
                        
                    })
                    let polygon = new AMap.Polygon({
                        path: newdata,  
                        fillColor: color[color_index%5], // 多边形填充颜色
                        fillOpacity: 0.5,
                        strokeColor: color[color_index%5], // 线条颜色
                        strokeOpacity:0.5
                    });
                    polygons.push(polygon);
                    color_index++
                }
            })
            map.clearMap();
            map.add(polygons);
            map.setFitView(polygons);
//50号院
// let coordinate_arr = [{"lng":114.507464,"lat":36.619302},{"lng":114.507486,"lat":36.619311},{"lng":114.509132,"lat":36.619203},{"lng":114.508966,"lat":36.617416},{"lng":114.508837,"lat":36.617335},{"lng":114.507791,"lat":36.617386},{"lng":114.507909,"lat":36.61904},{"lng":114.50741,"lat":36.619061},{"lng":114.50741,"lat":36.619061},{"lng":114.507453,"lat":36.619319}]
//             let newdata = coordinate_arr.map(item=>{
//                 return new AMap.LngLat(item.lng,item.lat)
//             })
           
//             console.log(newdata)

//             let polygon = new AMap.Polygon({
//                 path: newdata,  
//                 fillColor: '#FF2F5B', // 多边形填充颜色
//                 fillOpacity: 0.5,
//                 strokeColor: '#FF2F5B', // 线条颜色
//                 strokeOpacity:0.5
//             });
            
//             polygons.push(polygon);
//             map.clearMap();
//             map.add(polygons);
//             map.setFitView(polygons);
           
        },
        clear(){
            this.initStatus = true
            map.clearMap();
            map.add(this.polygons);
            map.setFitView(this.polygons);
            map.setZoom(10.5)
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.date = this.$util.FormatDate(new Date(),"yyyy年MM月dd日  HH:mm:ss") 
                        + "  星期" + this.$util.number2Chinese(new Date().getDay())
        this.getWeather()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
       this.initMap()
       
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style>
.amap-marker-label{
    border: 0;
    background-color: transparent;
}
.partyName{
    color:red;
    height:45px;
    line-height: 45px;
    color:#fff;
    background-image: url('../../assets/images/monitorctxf/maptitle.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding:0 20px;
    font-size:22px;
    cursor: pointer;
}
.partyNameSmall{
    font-size:16px;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    position: relative;
    width:100%;
    height:100%
}
.ctmap{
    width:100%;
    height: 100%
}
.content_container{
    position: absolute;
    top:0;
    left:0;
    right: 0;
    bottom:0;
    pointer-events: none
}

/*页面标题*/
.weatherPic{
    display: flex;
    width: 40px;
    height: 40px;
    margin-left: 10px;
}
.title_top{
    width: 376px;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 45px;

    margin: 28px 20px 0 20px;
    white-space:pre
}
.title_top_left{
    background-image: url('../../assets/images/monitorctxf/lefttitle.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    text-align: center;
    pointer-events: auto;
    
}
.title_top_right{
    background-image: url('../../assets/images/monitorctxf/righttitle.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
     pointer-events: auto;
}
.title_center_bg{
    position:fixed;
    top: 20px;
    left: 292px;
    right:292px;
    height:50px;
    background-image: url('../../assets/images/monitorctxf/LOGO.png');
    background-size: 100% 100%;
    background-repeat: no-repeat
}
.title_center{
    width:100%;
    text-align: center;
    font-weight: bold;
    font-size: 26px;
    color: #FFFFFF;
    line-height: 45px;

    background: linear-gradient(0deg, #BBBBBB 0%, #FFFFFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

/*左侧内容*/
.content_left{
    //float: left;
    margin-bottom:10px;
    margin-left:20px;
    margin-top:20px;
    //height: calc(100% - 95px);
    width: 455px;
    pointer-events: auto;
    .item{
        margin-bottom: 10px;
        width:100%
    }
}
.content_right{
    //float: right;
    margin-bottom:10px;
    margin-right:20px;
    margin-top:20px;
    //height: calc(100% - 95px);
    width: 455px;
    pointer-events: auto;
    .item{
        margin-bottom: 10px;
        width:100%
    }
}

.content_center{
    width:44%;
    height:500px;
    margin:0 auto;
    position: relative;
    top:40%;
    margin-top:-250px;
    pointer-events: auto;
}

.clear{
    position:fixed;
    z-index:2;
    right:490px;
    bottom:20px;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    line-height: 54px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    background: #7E0000;
    box-shadow: 0 0 5px #ff3c3c inset
}

.clear:active{
    background: #560000;
}

</style>